// extracted by mini-css-extract-plugin
export default {"root":"UserInfo-root","userInfoInput":"UserInfo-userInfoInput"};